<template>
  <div>
    <!-- Header: Personal Info -->

    <!-- Form: Personal Info Form -->
    <b-form>
      <b-form>
        <b-card class="border">
          <div class="d-flex align-items-center mb-1">
            <feather-icon icon="ProfileIcon" size="19" class="mr-50" />
            <h4 class="mb-0">Enrollment Information</h4>
          </div>

          <!-- Form: Add Inf -->
          <b-row class="mt-1">
          <!-- Field: Attributes - Funding Source -->
          <b-col cols="12" lg="2" md="3" xs="12">
            <b-form-group label="Funding Source" label-for="profile-attr-funding-source">
              <v-select
                id="profile-attr-funding-source"
                :value="profileDataLocal.attributes.fundingSource"
                :options="fundingSourceOptions"
                class="w-100"
                :clearable="false"
                :reduce="(val) => val.value"
                @input="(val) => (profileDataLocal.attributes.fundingSource = val)"
              />
            </b-form-group>
          </b-col>

          <!-- Field: Attributes - Payment Status -->
          <b-col v-if="false" cols="12" lg="2" md="3" xs="12">
            <b-form-group label="Payment Status" label-for="profile-attr-payment-status">
              <v-select
                id="profile-attr-payment-status"
                :value="profileDataLocal.attributes.paymentStatus"
                :options="paymentStatusOptions"
                class="w-100"
                :clearable="false"
                :reduce="(val) => val.value"
                @input="(val) => (profileDataLocal.attributes.paymentStatus = val)"
              />
            </b-form-group>
          </b-col>

          <!-- Field: Attributes - Submitted to VA -->
          <b-col cols="12" lg="2" md="3" xs="12">
            <b-form-group label="Submitted to VA" label-for="profile-attr-submitted-to-va">
              <v-select
                id="profile-attr-submitted-to-va"
                :value="profileDataLocal.attributes.submittedToVa"
                :options="submittedToVaOptions"
                class="w-100"
                :clearable="false"
                :reduce="(val) => val.value"
                @input="(val) => (profileDataLocal.attributes.submittedToVa = val)"
              />
            </b-form-group>
          </b-col>

          <!-- Field: coe uploaded -->
          <b-col cols="12" lg="2" md="3" xs="12">
            <b-form-group label="Uploaded COE" label-for="profile-attr-u-coe">
              <v-select
                id="profile-attr-u-coe"
                :value="profileDataLocal.attributes.uploadedCoe"
                :options="uploadedCoeOptions"
                class="w-100"
                :clearable="false"
                :reduce="(val) => val.value"
                @input="(val) => (profileDataLocal.attributes.uploadedCoe = val)"
              />
            </b-form-group>
          </b-col>

          <!-- Field: transcript uploaded -->
          <b-col cols="12" lg="2" md="3" xs="12">
            <b-form-group label="Uploaded Transcript" label-for="profile-attr-u-transcript">
              <v-select
                id="profile-attr-u-resume"
                :value="profileDataLocal.attributes.uploadedTranscript"
                :options="uploadedTranscriptOptions"
                class="w-100"
                :clearable="false"
                :reduce="(val) => val.value"
                @input="(val) => (profileDataLocal.attributes.uploadedTranscript = val)"
              />
            </b-form-group>
          </b-col>

          <!-- Field: resume uploaded -->
          <b-col cols="12" lg="2" md="3" xs="12">
            <b-form-group label="Uploaded Resume" label-for="profile-attr-u-resume">
              <v-select
                id="profile-attr-u-resume"
                :value="profileDataLocal.attributes.uploadedResume"
                :options="uploadedResumeOptions"
                class="w-100"
                :clearable="false"
                :reduce="(val) => val.value"
                @input="(val) => (profileDataLocal.attributes.uploadedResume = val)"
              />
            </b-form-group>
          </b-col>

          <!-- Field: location -->
          <b-col cols="12" lg="2" md="3" xs="12">
            <b-form-group label="Location" label-for="profile-attr-u-location">
              <v-select
                id="profile-attr-u-location"
                :value="profileDataLocal.attributes.location"
                :options="locationOptions"
                class="w-100"
                :clearable="false"
                :reduce="(val) => val.value"
                @input="(val) => (profileDataLocal.attributes.location = val)"
              />
            </b-form-group>
          </b-col>

        </b-row>

        <b-row class="mt-0">
          <!-- Field: Representative -->
          <b-col cols="12" lg="3" md="6" xs="12">
            <b-form-group label="Representative" label-for="profile-representative">
              <vue-autosuggest
                id="profile-representative"
                ref="autocomplete"
                v-model="representativeQuery"
                :suggestions="representativeSuggestions"
                :input-props="representativeInputProps"
                :section-configs="representativeSectionConfigs"
                :render-suggestion="representativeRenderSuggestion"
                :get-suggestion-value="representativeGetSuggestionValue"
                @input="representativeFetchResults"
              />
            </b-form-group>
          </b-col>

          <!-- Field: AIT (Base Unit) -->
          <b-col cols="12" lg="3" md="6" xs="12">
            <b-form-group label="AIT (Base Unit)" label-for="profile-military-ait">
              <b-form-input
                id="profile-military-ait"
                :value="profileDataLocal.enrollmentMilitaryAit"
                @input="(val) => (profileDataLocal.enrollmentMilitaryAit = val)"
                class="w-100"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" lg="3" md="6" xs="12">
            <b-form-group label="Acceptance Date" label-for="profile-acceptance-date">
              <b-form-datepicker id="profile-acceptance-date" v-model="profileDataLocal.acceptanceAt" class="mb-1" />
            </b-form-group>
          </b-col>
          </b-row>
        </b-card>

        <b-card class="border">
          <div class="d-flex align-items-center mb-1">
            <feather-icon icon="BookOpenIcon" size="19" class="mr-50" />
            <h4 class="mb-0">Preferred Enrollment</h4>
          </div>

          <b-row class="mt-1">
            <!-- Field: Pathway -->
            <b-col v-if="!profileDataLocal.preferred.course" cols="12" :lg="profileDataLocal.preferred.pathway ? 6 : 4" md="6" xs="12">
              <b-form-group label="Preferred Pathway" label-for="profile-pathway">
                <v-select
                  id="profile-pathway"
                  placeholder="Preferred Pathway"
                  :value="profileDataLocal.preferred.pathway"
                  :options="pathwaySuggestions"
                  class="w-100"
                  :reduce="(val) => val.value"
                  :clearable="true"
                  @search="searchForPathway"
                  @input="(val) => (profileDataLocal.preferred.pathway = val)"
                />
              </b-form-group>
            </b-col>

            <!-- Field: Course -->
            <b-col v-if="!profileDataLocal.preferred.pathway" cols="12" :lg="profileDataLocal.preferred.course ? 6 : 3" md="6" xs="12">
              <b-form-group label="Preferred Course" label-for="profile-course">
                <v-select
                  id="profile-course"
                  placeholder="Preferred Course"
                  :value="profileDataLocal.preferred.course"
                  :options="courseSuggestions"
                  class="w-100"
                  :reduce="(val) => val.value"
                  :clearable="true"
                  @search="searchForCourse"
                  @input="(val) => (profileDataLocal.preferred.course = val)"
                />
              </b-form-group>
            </b-col>

            <!-- Field: Pathway Date -->
            <b-col cols="12" lg="3" md="6" xs="12">
              <b-form-group label="Preferred Start Date" label-for="preferredDate">
                <b-form-datepicker id="preferredDate" v-model="profileDataLocal.preferred.startDate" class="mb-1" />
              </b-form-group>
            </b-col>

            <!-- Field: Retake -->
            <b-col cols="12" lg="2" md="2" xs="12">
              <b-form-group label="Pathway Retake" label-for="profile-section-retake">
                <v-select
                  id="profile-section-retake"
                  :value="profileDataLocal.attributes.retake"
                  :options="yesNoActualOptions"
                  class="w-100"
                  :clearable="false"
                  :reduce="(val) => val.value"
                  @input="(val) => (profileDataLocal.attributes.retake = val)"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-card>

        <b-card class="border">
          <div class="d-flex align-items-center mb-1">
            <feather-icon icon="ActivityIcon" size="19" class="mr-50" />
            <h4 class="mb-0">Profile Status</h4>
          </div>

          <b-row class="mt-1">
          <!-- Field: Status -->
          <b-col cols="12" lg="2" md="6" xs="12">
            <b-form-group label="Status" label-for="profile-status">
              <v-select
                id="profile-status"
                :value="profileDataLocal.status"
                :options="statusOptions"
                class="w-100"
                :clearable="false"
                :reduce="(val) => val.value"
                @input="(val) => (profileDataLocal.status = val)"
              />
            </b-form-group>

            <!-- Field: Profile Status Update Date -->
            <template v-if="profileData && profileDataLocal && profileData.status !== profileDataLocal.status">
              <b-form-group label="Propagate (cascade to sections)" label-for="propagation-mode">
                <v-select
                  id="propagation-mode"
                  v-model="propagation.mode"
                  :options="propagationOptions"
                  :reduce="(val) => val.value"
                  :clearable="false"
                  class="d-inline-block"
                />
              </b-form-group>
              <b-form-group v-if="'future' === propagation.mode" label="Effective As Of" label-for="propagation-effectiveAt">
                <b-form-datepicker id="propagation-effectiveAt" v-model="propagation.effectiveAt" />
              </b-form-group>
            </template>
          </b-col>

          <!-- Field: Profile Status Reason -->
          <b-col v-if="shouldProvideReason" cols="12" lg="4" md="6" xs="12">
            <b-form-group label="Status Reason" label-for="profile-status-reason">
              <b-form-input id="profile-status-reason" v-model="profileDataLocal.statusReason" class="w-100" />
            </b-form-group>
          </b-col>

          <!-- Field: Profile Status Update Date -->
          <b-col cols="12" lg="3" md="6" xs="12">
            <b-form-group label="Status Date" label-for="profile-status-date">
              <b-form-datepicker id="profile-status-date" v-model="profileDataLocal.statusDate" class="mb-1" />
            </b-form-group>
          </b-col>

          <!-- Field: Mitigating Circumstances (DEV-753) -->
          <b-col v-if="showMitigatingCircumstance" cols="12" lg="4" md="6" xs="12">
            <b-form-group
              label="Mitigating Circumstances"
              label-for="profile-mitigating-circumstance"
              description="(with student declaration or evidence)"
            >
              <v-select
                id="profile-mitigating-circumstance"
                v-model="profileDataLocal.mitigatingCircumstance"
                :options="mitigatingCircumstanceOptions"
                :reduce="(val) => val.value"
                class="w-100"
              />
            </b-form-group>
          </b-col>

          <!-- Field: Graduation Date (only when graduated) -->
          <b-col v-if="isGraduated" cols="12" lg="3" md="6" xs="12">
            <b-form-group label="Graduation Date" label-for="profile-graduation-date">
              <b-form-datepicker id="profile-graduation-date" v-model="profileDataLocal.graduationDate" class="mb-1" />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row v-if="showReassignSection">
          <b-col cols="12">
            <h4 class="mb-0">Leave of Absence</h4>
          </b-col>

          <!-- Field: Profile Reassign Reason -->
          <b-col cols="12" :lg="lastOptionsSelected === 'reassignReason' ? 12 : 3" md="12" xs="12">
            <b-form-group label="Reassign Reason" label-for="profile-status-reason">
              <b-form-input
                @focusin="lastOptionsSelected = 'reassignReason'"
                @focusout="lastOptionsSelected = undefined"
                id="profile-reassign-reason"
                v-model="profileDataLocal.reassignReason"
                class="w-100"
              />
            </b-form-group>
          </b-col>

          <!-- Field: Reassign From -->
          <b-col cols="12" lg="3" md="6" xs="12">
            <b-form-group label="Reassign From" label-for="profile-reassignFrom">
              <v-select
                id="profile-reassignFrom"
                placeholder="Reassign From"
                :value="profileDataLocal.reassignFrom"
                :options="cohortSuggestions"
                class="w-100"
                :reduce="(val) => val.value"
                :clearable="true"
                @search="searchForCohort"
                @input="(val) => (profileDataLocal.reassignFrom = val)"
              />
            </b-form-group>
          </b-col>

          <!-- Field: LOA Start Date -->
          <b-col cols="12" lg="3" md="6" xs="12">
            <b-form-group label="LoA Start Date" label-for="loa-start-date">
              <b-form-datepicker id="loa-start-date" v-model="profileDataLocal.reassignStart" class="mb-1" />
            </b-form-group>
          </b-col>

          <!-- Field: LOA End Date -->
          <b-col cols="12" lg="3" md="6" xs="12">
            <b-form-group label="LoA End Date" label-for="loa-start-date">
              <b-form-datepicker id="loa-end-date" v-model="profileDataLocal.reassignEnd" class="mb-1" />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row v-if="showTransferCreditSection">
          <b-col cols="12">
            <h4 class="mb-0">Transfer of Credit</h4>
          </b-col>

          <b-col cols="12" lg="12" md="12" xs="12">
            <b-form-group label="Reason / Notes" label-for="profile-section-toc-note">
              <b-form-input
                id="profile-section-toc-note"
                :value="profileDataLocal.sections[this.sectionId].toc.notes"
                @input="(val) => (profileDataLocal.sections[this.sectionId].toc.notes = val)"
                class="w-100"
              />
            </b-form-group>
          </b-col>
        </b-row>
        </b-card>

      </b-form>
    </b-form>
  </div>
</template>

<script>
import { BCard, BCol, BForm, BFormDatepicker, BFormGroup, BFormInput, BRow } from 'bootstrap-vue';

import { ref } from '@vue/composition-api';
import vSelect from 'vue-select';
import useProfiles from '../../useProfiles';
import { isMitigatingStatus, mitigatingCircumstanceOptions } from '../../profileOptions';
import { VueAutosuggest } from 'vue-autosuggest';

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BFormDatepicker,
    vSelect,
    VueAutosuggest,
  },
  inject: ['profileEdit'],
  watch: {
    representativeSelected(val) {
      this.profileDataLocal.representativeSelected = val;
    },
  },
  computed: {
    profileData() {
      return this.profileEdit.profileData;
    },
    profileDataLocal() {
      return this.profileEdit.profileDataLocal;
    },
    sectionId() {
      return this.profileEdit.sectionId;
    },
    propagation() {
      return this.profileEdit.propagation;
    },
    propagationOptions() {
      return this.profileEdit.propagationOptions;
    },
    showMitigatingCircumstance() {
      return isMitigatingStatus(this.profileDataLocal.status);
    },
    shouldProvideReason() {
      return (
        this.profileDataLocal.statusReason ||
        ['withdrew_s1', 'withdrew_s2', 'withdrew_s3', 'withdrew_s3_bah', 'terminated', 'not_graduated'].includes(this.profileDataLocal.status)
      );
    },

    isGraduated() {
      return this.profileDataLocal.status === 'graduated';
    },

    showReassignSection() {
      return (
        this.profileDataLocal.status === 'leave_of_absence' ||
        this.profileDataLocal.reassignAt ||
        this.profileDataLocal.reassignReason ||
        this.profileDataLocal.reassignStart ||
        this.profileDataLocal.reassignEnd ||
        this.profileDataLocal.reassignFrom
      );
    },

    showTransferCreditSection() {
      return this.sectionId && this.profileDataLocal.sections[this.sectionId].toc.enabled; //this.profileDataLocal.toc && this.profileDataLocal.toc.enabled &&
    },
  },
  data: () => {
    return {
      submit: {
        sync: false,
      },
      attributes: {
        relocatable: 'no',
        remote: 'no',
        clearance: 'none',
        location: 'virtual',
        veteran: true,
      },

      options: {
        number: {
          numeral: true,
          numeralThousandsGroupStyle: 'thousand',
        },
      },

      lastOptionsSelected: '',
    };
  },
  methods: {
    async doSelectRepresentative() {
      if (!this.representativeSelected) {
        return;
      }

      this.$store
        .dispatch('placementStoreModule/addStudentsToCohort', {
          cohortId: this.cohortData.id,
          studentIds: [this.representativeSelected.id],
        })
        .then((response) => {
          console.log('updated section', response);

          console.log(response.data);

          this.$emit('refresh');

          this.representativeQuery = undefined;
          this.representativeFetchResults();
        })
        .catch((e) => {
          console.error('failed to update section', e);
        });
    },
    representativeFetchResults() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        const usersPromise = this.$store.dispatch('userStoreModule/fetchUsers', {
          search: this.representativeQuery,
        });

        Promise.all([usersPromise]).then((values) => {
          this.representativeSuggestions = [];

          const users = values[0].data.results;

          if (users.length) {
            this.representativeSuggestions.push({ name: 'users', data: users });
          }
        });
      }, 250);
    },
    representativeRenderSuggestion(row) {
      return `${row.item.name}`;
    },
    representativeGetSuggestionValue(row) {
      if (row.item) {
        return this.representativeRenderSuggestion(row);
      }
      return `${row.name}`;
    },

    cohortRenderSuggestion(suggestion) {
      return suggestion.item.name;
    },
    cohortGetSuggestionValue(suggestion) {
      const { item } = suggestion;
      return item.name;
    },
    async searchForCohort(search) {
      const filter = { search, limit: 100, sortBy: 'createdAt:desc' };

      if (this.profileDataLocal.pathway) {
        filter.pathway = this.profileDataLocal.pathway;
      } else if (this.profileDataLocal.course) {
        filter.course = this.profileDataLocal.pathway;
      }

      const response = await this.$store.dispatch('rosterStoreModule/fetchPathwayCohortList', filter);
      const cohorts = response.data.results;

      this.cohortSuggestions = cohorts.map((p) => {
        const { id, name } = p;
        return { value: id, label: name };
      });
    },
    pathwayRenderSuggestion(suggestion) {
      return suggestion.item.name;
    },
    pathwayGetSuggestionValue(suggestion) {
      const { item } = suggestion;
      return item.name;
    },
    async searchForPathway(search) {
      const response = await this.$store.dispatch('rosterStoreModule/fetchPathwayList', { search, limit: 100 });
      const pathways = response.data.results;

      this.pathwaySuggestions = pathways.map((p) => {
        const { id } = p;
        let { name } = p;
        if (!name.includes('Pathway')) {
          name += ' Pathway';
        }
        return { value: id, label: name };
      });
    },
    courseRenderSuggestion(suggestion) {
      return suggestion.item.name;
    },
    courseGetSuggestionValue(suggestion) {
      const { item } = suggestion;
      return item.name;
    },
    async searchForCourse(search) {
      const response = await this.$store.dispatch('rosterStoreModule/fetchCourseList', { search, limit: 100 });
      const courses = response.data.results;

      this.courseSuggestions = courses.map((p) => {
        const { id, name } = p;
        return { value: id, label: name };
      });
    },

    async ensurePreferredPathwayOption() {
      const id = (this.profileDataLocal.preferred || {}).pathway;
      if (!id || this.pathwaySuggestions.some((s) => s.value === id)) {
        return;
      }

      try {
        const response = await this.$store.dispatch('rosterStoreModule/fetchPathway', { id });
        const pathway = response.data;
        if (!pathway || !pathway.name) {
          return;
        }

        let { name } = pathway;
        if (!name.includes('Pathway')) {
          name += ' Pathway';
        }
        this.pathwaySuggestions = [{ value: id, label: name }, ...this.pathwaySuggestions];
      } catch (error) {
        // Leave the raw value if the record can't be loaded.
      }
    },

    async ensurePreferredCourseOption() {
      const id = (this.profileDataLocal.preferred || {}).course;
      if (!id || this.courseSuggestions.some((s) => s.value === id)) {
        return;
      }

      try {
        const response = await this.$store.dispatch('rosterStoreModule/fetchCourse', { id });
        const course = response.data;
        if (!course || !course.name) {
          return;
        }

        this.courseSuggestions = [{ value: id, label: course.name }, ...this.courseSuggestions];
      } catch (error) {
        // Leave the raw value if the record can't be loaded.
      }
    },

    async loadProfile() {
      await this.searchForPathway('');
      await this.searchForCourse('');

      await this.ensurePreferredPathwayOption();
      await this.ensurePreferredCourseOption();

      if (this.profileDataLocal.reassignFrom) {
        this.searchForCohort('');
      }

      this.profileDataLocal.representativeSelected = this.profileData.representative;
      if (this.profileDataLocal.representativeSelected) {
        this.representativeQuery = this.profileDataLocal.representativeSelected.name;
      }
    },
  },
  mounted() {
    this.loadProfile();
  },
  setup() {
    const representativeQuery = ref('');
    const representativeSuggestions = ref([]);
    const representativeSelected = ref({});
    const representativeSectionConfigs = {
      users: {
        limit: 10,
        label: 'Users',
        onSelected: (selected) => {
          representativeSelected.value = selected.item;
        },
      },
    };

    const representativeInputProps = {
      id: 'autosuggest__input_ajax',
      placeholder: 'Search for users',
      class: 'form-control',
      name: 'ajax',
    };

    const {
      statusOptions,
      clearanceOptions,
      relocatableOptions,
      remoteOptions,
      fundingSourceOptions,
      paymentStatusOptions,
      submittedToVaOptions,
      uploadedCoeOptions,
      uploadedResumeOptions,
      uploadedTranscriptOptions,
      yesNoActualOptions,
      locationOptions,
    } = useProfiles();

    const cohortQuery = ref('');
    const cohortSuggestions = ref([]);
    const cohortSelected = ref(undefined);
    const cohortSectionConfigs = {
      cohorts: {
        limit: 10,
        label: 'Cohorts',
        onSelected: (selected) => {
          cohortSelected.value = selected.item;
        },
      },
    };

    const cohortInputProps = {
      id: 'autosuggest__input_ajax',
      placeholder: 'Search for cohorts',
      class: 'form-control',
      name: 'ajax',
    };

    const pathwayQuery = ref('');
    const pathwaySuggestions = ref([]);
    const pathwaySelected = ref(undefined);
    const pathwaySectionConfigs = {
      pathways: {
        limit: 10,
        label: 'Pathways',
        onSelected: (selected) => {
          pathwaySelected.value = selected.item;
        },
      },
    };

    const pathwayInputProps = {
      id: 'autosuggest__input_ajax',
      placeholder: 'Search for pathways',
      class: 'form-control',
      name: 'ajax',
    };

    const courseQuery = ref('');
    const courseSuggestions = ref([]);
    const courseSelected = ref(undefined);
    const courseSectionConfigs = {
      courses: {
        limit: 10,
        label: 'Courses',
        onSelected: (selected) => {
          courseSelected.value = selected.item;
        },
      },
    };

    const courseInputProps = {
      id: 'autosuggest__input_ajax',
      placeholder: 'Search for courses',
      class: 'form-control',
      name: 'ajax',
    };

    return {
      representativeQuery,
      representativeSuggestions,
      representativeSelected,
      representativeSectionConfigs,
      representativeInputProps,

      statusOptions,
      mitigatingCircumstanceOptions,
      clearanceOptions,
      relocatableOptions,
      remoteOptions,
      fundingSourceOptions,
      paymentStatusOptions,
      submittedToVaOptions,
      uploadedCoeOptions,
      uploadedResumeOptions,
      uploadedTranscriptOptions,
      yesNoActualOptions,
      locationOptions,

      //
      cohortQuery,
      cohortSuggestions,
      cohortSectionConfigs,
      cohortInputProps,
      cohortSelected,
      pathwayQuery,
      pathwaySuggestions,
      pathwaySectionConfigs,
      pathwayInputProps,
      pathwaySelected,
      courseQuery,
      courseSuggestions,
      courseSectionConfigs,
      courseInputProps,
      courseSelected,
    };
  },
};
</script>

<style lang="scss" scoped>
::v-deep .card {
  margin-bottom: 1rem;
}

::v-deep .card-body {
  padding-top: 1.25rem;
  padding-bottom: 0.75rem;
}

::v-deep .form-group {
  margin-bottom: 0.75rem;
}
</style>
<style lang="scss">
@import '@core/scss/vue/libs/vue-autosuggest.scss';

pre {
  min-height: 295px;
  padding: 1.5rem;
  margin-bottom: 0;
  border-radius: 0.5rem;
}

.attr-tag {
  float: right;
  margin: 2.5px 0 2.5px 5px;
}
</style>
